<template>
  <ReportPage></ReportPage>
</template>

<script>
import { defineAsyncComponent } from "vue";
const ReportPage = defineAsyncComponent(() =>
  import("@/components/reports/ReportFileTestReports")
);
export default {
  name: "ResultFileStatusDetailsReport",
  components: {
    ReportPage,
  },
};
</script>

<style>
table {
  border-collapse: collapse;
}
table td {
  padding: 0px;
}
</style>
